import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { mapParamsBySchema, mapRowsBySchema } from '../util';
import Global from '../Services/Common/Global';
import { apiRequest } from '../Services/Common/ApiRequest';
import { handleQuerySuccess } from '../Hooks/apis/useQuriesSuccess';
import useSearchMutaion from '../Hooks/apis/useSearchMutaion';
import { Layout_Schema } from './Layout_Schema';
import useSaveMutation from '../Hooks/apis/useSaveMutaion';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(Layout_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Account', 'GetInfo', params],
    queryFn: () => apiRequest('login', Global.urls.Account.GetInfo, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    onSuccess?.(query.data);
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
export const useSearch2 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(Layout_Schema.mapper.search2);

  const query = useQuery({
    queryKey: ['Home', 'getHomeData', params],
    queryFn: () => apiRequest('post', Global.urls.Home.getHomeData, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch3 = (options = {}) => {
  const { onSuccess } = options;
  // const { userInfo } = useSelector((s) => s.BaseInfo);
  // const hasAuth = ['BUSINESS_OWNER', 'HEAD_MANAGER'].includes(userInfo?.authCd);

  const params = mapParamsBySchema(Layout_Schema.mapper.search3);

  const query = useQuery({
    queryKey: ['Home', 'getDepLast', params],
    queryFn: () => apiRequest('post', Global.urls.Utility.getDepLast, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch4 = (options = {}) => {
  const { onSuccess } = options;

  const menuInfo = useSelector((s) => s.BaseInfo.menuInfo);

  const permitMenu = menuInfo?.find(
    (m) =>
      m.menuId === 'M_Permit' ||
      m.proId === 'M_PER_CUSTOM' ||
      m.proId === 'M_PER_NEW'
  );

  const proId = permitMenu?.proId;

  const isCustom = proId === 'M_PER_CUSTOM';
  const isNew = proId === 'M_PER_NEW';
  const isBasic = !isCustom && !isNew;

  let url = Global.urls.Permit.getPerBasicR4;
  if (isCustom) url = Global.urls.Permit.getPerCustomR3;
  if (isNew) url = Global.urls.Permit.getPerNewR6;

  const params = mapParamsBySchema(Layout_Schema.mapper.search4);

  const query = useQuery({
    queryKey: [
      'Home',
      'getPermitList',
      isCustom ? 'custom' : isNew ? 'new' : 'basic',
      params,
    ],
    queryFn: () => apiRequest('post', url, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch5 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(Layout_Schema.mapper.search5, context);
    return apiRequest('post', Global.urls.WorkStop.getWosBasicR2, params);
  }, successOptions);
};

export const useSearch6 = (options = {}) => {
  const { onSuccess } = options;

  const params = mapParamsBySchema(Layout_Schema.mapper.search6);

  const query = useQuery({
    queryKey: ['Utility', 'getGongjongList', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Utility.getGongjongList, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 보호구 미수령(미서명) 건 조회 — 홈 M_Equipment 메뉴 뱃지용 */
export const useSearch7 = (options = {}) => {
  const { onSuccess } = options;
  const menuInfo = useSelector((s) => s.BaseInfo.menuInfo);
  const { dateFrom, dateTo } = useSelector((s) => s.equipment);
  const hasEquipMenu = menuInfo?.some((m) => m.menuId === 'M_Equipment');

  const params = mapParamsBySchema(Layout_Schema.mapper.search7, {
    dateFrom,
    dateTo,
  });

  const query = useQuery({
    queryKey: ['Home', 'getEisBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.EquipIssuanceStatus.getEisBasicR1, params),
    enabled: hasEquipMenu,
  });

  useEffect(() => {
    if (!hasEquipMenu) {
      onSuccess?.([]);
      return;
    }
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [hasEquipMenu, dateFrom, dateTo, query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 로그아웃 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, Layout_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.Account.logout, ...payload);
  }, options);
};
